import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../../config/config';

export function PrintLedger() {
  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const token = localStorage.getItem('token');

  const queryParams = new URLSearchParams(location.search);
  const supId = queryParams.get('supId');
  const startDate = queryParams.get('startDate');
  const endDate = queryParams.get('endDate');

  useEffect(() => {
    if (supId) {
      setLoading(true);
      fetch(`${config.baseUrl}/api/supplierDetails/ledger?supId=${supId}&startDate=${startDate}&endDate=${endDate}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then(data => {
        const result = Array.isArray(data) ? data : (data.data || []);
        setLedgerData(result);
        setLoading(false);
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
    }
  }, [supId, startDate, endDate, token]);

  useEffect(() => {
    if (!loading && ledgerData.length > 0) {
      const timer = setTimeout(() => {
        window.print();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [loading, ledgerData]);

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>📄 Preparing Report...</div>;

  // API response se Supplier Name nikalna (Pehli row se)
  const displaySupName = ledgerData[0]?.sup_name || "N/A";

  return (
    <div className="print-container">
      <style>
        {`
          .print-container { padding: 40px; font-family: 'Segoe UI', sans-serif; background: white; color: #000; }
          .header-section { text-align: center; border-bottom: 2px solid #000; padding-bottom: 15px; margin-bottom: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #000; padding: 10px; text-align: left; font-size: 13px; }
          th { background-color: #f3f4f6 !important; font-weight: bold; }
          
          @media print {
            body { visibility: hidden; }
            .print-container, .print-container * { visibility: visible; }
            .print-container { position: absolute; left: 0; top: 0; width: 100%; padding: 0; margin: 0; }
            .no-print { display: none !important; }
            th { background-color: #f3f4f6 !important; -webkit-print-color-adjust: exact; }
          }
        `}
      </style>

      <div className="header-section">
        <h1 style={{ margin: 0, fontSize: '24px' }}>SUPPLIER LEDGER REPORT</h1>
        
        {/* SUPPLIER NAME SHOW HERE */}
        <div style={{ marginTop: '15px', fontSize: '18px' }}>
          <strong>Supplier Name: </strong> 
          <span style={{ textTransform: 'uppercase', borderBottom: '1px solid #333' }}>
            {displaySupName}
          </span>
        </div>

        <p style={{ margin: '10px 0 0 0', fontSize: '14px' }}>
          <strong>Period:</strong> {startDate} to {endDate}
        </p>
      </div>

      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th style={{ textAlign: 'right' }}>Total Bill</th>
            <th style={{ textAlign: 'right' }}>Paid</th>
            <th style={{ textAlign: 'center' }}>%</th>
            <th style={{ textAlign: 'right' }}>Balance</th>
          </tr>
        </thead>
        <tbody>
          {ledgerData.map((row, index) => {
            const isAdv = row.pay_type?.toLowerCase().includes('adv');
            return (
              <tr key={index}>
                <td>{new Date(row.created_at).toLocaleDateString('en-GB')}</td>
                <td style={{ textTransform: 'uppercase' }}>{row.pay_type}</td>
                <td style={{ textAlign: 'right' }}>{parseFloat(row.total_amount || 0).toLocaleString()}</td>
                <td style={{ textAlign: 'right' }}>{isAdv ? '-' : parseFloat(row.pay_amount || 0).toLocaleString()}</td>
                <td style={{ textAlign: 'center' }}>{row.pay_percent || 0}%</td>
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{parseFloat(row.running_balance || 0).toLocaleString()}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div style={{ marginTop: '20px', textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
        Current Balance: {parseFloat(ledgerData[0]?.running_balance || 0).toLocaleString()}
      </div>

      <div className="no-print" style={{ marginTop: '30px', textAlign: 'center' }}>
         <button 
           onClick={() => window.print()} 
           style={{ padding: '10px 20px', background: '#000', color: '#fff', cursor: 'pointer', borderRadius: '5px' }}
         >
           Print Report
         </button>
      </div>
    </div>
  );
}